import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ApiConstant } from '../../utils/api-constant/api-constant.service';
import { ReqBodyLogin } from './auth-customer.model';
export class AuthCustomerService {
/**
 * @param {?} http
 * @param {?} apiConstantService
 */
constructor(
private http: HttpClient,
private apiConstantService: ApiConstant,
  ) {}
/**
 * @param {?} reqBody
 * @return {?}
 */
public postLogin(reqBody: ReqBodyLogin): Observable<any> {
    return this.http.post(
      `${this.apiConstantService.gatewayUrl}/cpe/web/v2/login`,
      reqBody,
    );
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpClient, },
{type: ApiConstant, },
];
}

function AuthCustomerService_tsickle_Closure_declarations() {
/** @type {?} */
AuthCustomerService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AuthCustomerService.ctorParameters;
/** @type {?} */
AuthCustomerService.prototype.http;
/** @type {?} */
AuthCustomerService.prototype.apiConstantService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
